import { FETCH_PRODUCT_DETAIL_ERROR, FETCH_PRODUCT_DETAIL_REQUEST, FETCH_PRODUCT_DETAIL_SUCCESS } from "./productDetailContstantTypes"

const initialTripState = {
    loading: true,
    productDetails: {
        },
    error: ''
}
export const productDetailReducer = (state = initialTripState, action) => {
    
    switch (action.type) {
        case FETCH_PRODUCT_DETAIL_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_PRODUCT_DETAIL_SUCCESS:
           
            return {
                ...state,
                productDetails: action.payload,
                loading: false,
                error: ''
            }
        case FETCH_PRODUCT_DETAIL_ERROR:
            return {
                ...state,
                productDetails: {},
                loading: false,
                error: action.payload
            }
        default:
           return state;
    }
}
